import { TVisibilityTrigger } from 'core-components/library/popup'

export const handleByClick = (visibilityTrigger: TVisibilityTrigger | undefined) => {
  return (
    visibilityTrigger === TVisibilityTrigger.Click ||
    visibilityTrigger === TVisibilityTrigger.ClickHover
  )
}

export const handleByHover = (visibilityTrigger: TVisibilityTrigger | undefined) => {
  return (
    visibilityTrigger === TVisibilityTrigger.Hover ||
    visibilityTrigger === TVisibilityTrigger.ClickHover
  )
}
